// `React` in scope for the classic-runtime renderchecks — see `CrossIcon`.
import React from "react";
import { StyleSheet } from "react-native";
import Svg, { Defs, LinearGradient, Rect, Stop } from "react-native-svg";

// Figma 125:266: linear-gradient(177.9deg, #EEF6FF 8.85%, #FFFFFF 86.95%) — vertical here, as the
// 2° tilt is under 1% of the width on a header this shape. An SVG layer, never a background on
// the header: that renders as a <button> on web, whose host CSS erases fills (CLAUDE.md).
export function HeaderGradient() {
  return (
    <Svg style={StyleSheet.absoluteFill} width="100%" height="100%" preserveAspectRatio="none">
      <Defs>
        <LinearGradient id="profileHeaderGradient" x1="0" y1="0" x2="0" y2="1">
          <Stop offset="0.0885" stopColor="#EEF6FF" />
          <Stop offset="0.8695" stopColor="#FFFFFF" />
        </LinearGradient>
      </Defs>
      <Rect width="100%" height="100%" fill="url(#profileHeaderGradient)" />
    </Svg>
  );
}

HeaderGradient.displayName = "HeaderGradient";
export default HeaderGradient;
